import { render, staticRenderFns } from "./ListDimension.vue?vue&type=template&id=7960fa9c&"
import script from "./ListDimension.vue?vue&type=script&lang=js&"
export * from "./ListDimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports